import React, { useState, useEffect } from "react";
import {
  TextField,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  MenuItem,
  DialogTitle,
  Box,
  Stack,
  FormControlLabel,
  Typography,
  Checkbox,
} from "@mui/material";
import addStore from "../../api/store/addStore";
import Select, { SelectChangeEvent } from "@mui/material/Select";
import { CITIES } from "../../data/CITIES";
import setTags from "../../api/store/setTags";
import getTags from "../../api/store/getTags";
import updateStore from "../../api/store/updateStore";
const storeStatus = {
  ClosedPermanently: "closed_permanently",
  Open: "open",
  Close: "close",
};
const defaultStore = {
  Code: "",
  Name: "",
  City: "",
  District: "",
  Address: "",
  Phone: "",
  Tables: 6,
  Tags: [],
  Status: storeStatus.Open,
  Description: "",
  IntervalMinutes: 30,
  Promotions: [
    // {
    //   QuantityThreshold: 5,
    //   AmountThreshold: 0,
    //   RewardType: "Quantity",
    //   RewardValue: 5,
    // },
    // {
    //   QuantityThreshold: 8,
    //   AmountThreshold: 0,
    //   RewardType: "Quantity",
    //   RewardValue: 7,
    // },
    {
      QuantityThreshold: 0,
      AmountThreshold: 200,
      RewardType: "Point",
      RewardValue: 1,
    },
  ],
};
const AddStoreDialog = ({ isAdd, store, open, setOpen }) => {
  const [storeData, setStoreData] = useState(defaultStore);
  const [selectedCity, setSelectedCity] = useState("");
  const [tags, setTagsState] = useState([]);
  useEffect(() => {
    const fetchTags = async () => {
      try {
        const data = await getTags();

        setTagsState(data.tags); // Adjust this if data structure differs
      } catch (err) {}
    };

    fetchTags();
    if (!isAdd && store) {
      // Ensure Tags is initialized if not present in the store object
      const updatedStore = {
        ...store,
        Tags: store.Tags || [],
      };

      setStoreData(updatedStore);
    } else {
      setStoreData(defaultStore);
    }
  }, [isAdd, store, open]);

  const StoreStatusSelect = () => {
    return (
      <>
        <Select
          name="Status"
          color="info"
          fullWidth
          value={storeData.Status || ""}
          onChange={handleChange}
          label="狀態"
        >
          <MenuItem color="info" value={storeStatus.Open}>
            營業
          </MenuItem>
          <MenuItem color="info" value={storeStatus.Close}>
            關店
          </MenuItem>
          <MenuItem color="info" value={storeStatus.ClosedPermanently}>
            永久停業
          </MenuItem>
        </Select>
      </>
    );
  };
  const IntervalMinutesSelect = () => {
    return (
      <>
        <Select
          name="IntervalMinutes"
          color="info"
          fullWidth
          value={storeData.IntervalMinutes || 30}
          onChange={handleChange}
          label="單位分鐘"
        >
          <MenuItem color="info" value={30}>
            30
          </MenuItem>
          <MenuItem color="info" value={60}>
            60
          </MenuItem>
        </Select>
      </>
    );
  };
  const handleClose = () => {
    setOpen(false);
  };
  const generatePromotionFields = () => {
    return storeData.Promotions?.map((promotion, index) => (
      <div key={index}>
        {promotion.RewardType === "Quantity" && (
          <>
            <Typography>時數促銷 #{index + 1}</Typography>
            <Stack direction={"row"} spacing={1} marginTop={1}>
              <TextField
                name={`${index}.QuantityThreshold`}
                label="滿時數"
                disabled={true}
                color="secondary"
                variant="outlined"
                value={storeData.Promotions[index].QuantityThreshold || 0}
                onChange={handlePromotionChange}
              />
              <TextField
                name={`${index}.RewardValue`}
                label="送"
                disabled={true}
                color="secondary"
                variant="outlined"
                value={storeData.Promotions[index].RewardValue || 0}
                onChange={handlePromotionChange}
              />
            </Stack>
          </>
        )}
        {promotion.RewardType === "Point" && (
          <>
            {" "}
            <Typography>點數促銷 #{index + 1}</Typography>
            <Stack direction={"row"} spacing={1} marginTop={1}>
              <TextField
                name={`${index}.AmountThreshold`}
                label="滿金額"
                color="secondary"
                variant="outlined"
                value={storeData.Promotions[index].AmountThreshold || 0}
                onChange={handlePromotionChange}
              />
              <TextField
                name={`${index}.RewardValue`}
                label="送"
                color="secondary"
                variant="outlined"
                value={storeData.Promotions[index].RewardValue || 0}
                onChange={handlePromotionChange}
              />
            </Stack>
          </>
        )}
      </div>
    ));
  };

  const handlePromotionChange = (event) => {
    const { name, value } = event.target;

    // Split the name to extract promotion index and property name
    const [promotionIndex, propertyName] = name.split(".");

    setStoreData((prevStoreData) => {
      // Make a deep copy of the previous store data
      const newStoreData = JSON.parse(JSON.stringify(prevStoreData));

      // Update the specific promotion property, ensuring immutability
      if (
        newStoreData.Promotions &&
        promotionIndex < newStoreData.Promotions.length
      ) {
        newStoreData.Promotions[promotionIndex] = {
          ...newStoreData.Promotions[promotionIndex],
          [propertyName]: Number(value),
        };
      }

      return newStoreData;
    });
  };

  const handleChange = (event) => {
    const { name, value } = event.target;
    setStoreData({
      ...storeData,
      [name]: value,
    });
  };
  const handleTagChange = (event) => {
    const { name, checked } = event.target;
    const newTags = checked
      ? [...storeData.Tags, name]
      : storeData.Tags.filter((tag) => tag !== name);

    setStoreData((prevStoreData) => ({
      ...prevStoreData,
      Tags: newTags,
    }));
  };

  const generateTagToggles = () => (
    <>
      <Typography marginRight={1} color={"error"}>
        注意:標籤僅供顯示給客人，內容不會影響任何優惠。
      </Typography>
      <Box direction="row" alignItems={"center"}>
        <Typography marginRight={1} variant="h6">
          標籤
        </Typography>
        {tags?.map((tag, index) => (

          <FormControlLabel
          
            key={index}
            control={
              <Checkbox
                color="warning"
                checked={storeData.Tags?.includes(tag)}
                onChange={handleTagChange}
                name={tag}
              />
            }
            label={tag}
          />
        ))}
      </Box>
    </>
  );

  const handleSubmit = async (event) => {
    event.preventDefault();
    if (isAdd) {
      try {
        const response = await addStore(
          storeData.Code,
          storeData.Name,
          storeData.City,
          storeData.District,
          storeData.Address,
          storeData.Phone,
          storeData.Tables, // Assuming Tables as JSON string
          storeData.Description,
          storeData.Status,
          storeData.IntervalMinutes,
          storeData.Tags,
          storeData.Promotions
        );

        handleClose();
      } catch (error) {
        console.error("Failed to add store:", error);
      }
    } else {
      try {
        const response = await updateStore(storeData.Code, storeData);

        handleClose();
      } catch (error) {
        console.error("Failed to update store:", error);
      }
    }
  };

  return (
    <Dialog maxWidth={"lg"} open={open} onClose={handleClose}>
      <DialogTitle align="center">
        {isAdd ? "新增店家" : "編輯店家"}
      </DialogTitle>
      <form onSubmit={handleSubmit}>
        <DialogContent>
          <Stack spacing={5} direction={"row"}>
            <Box width={"50%"} flexDirection={"colunm"}>
              <TextField
                autoFocus
                margin="dense"
                name="Code"
                label="店號"
                color="secondary"
                required={true}
                variant="outlined"
                fullWidth
                value={storeData.Code || ""}
                onChange={handleChange}
              />
              <TextField
                margin="dense"
                name="Name"
                label="店名(限6個字)"
                required={true}
                color="secondary"
                variant="outlined"
                fullWidth
                value={storeData.Name || ""}
                onChange={handleChange}
              />

              <TextField
                id="city-select"
                select
                name="City"
                label="選擇城市"
                color="info"
                fullWidth
                value={storeData.City || ""}
                onChange={handleChange}
              >
                {CITIES.map((city, index) => (
                  <MenuItem key={index} value={city}>
                    {city}
                  </MenuItem>
                ))}
              </TextField>
              <TextField
                margin="dense"
                name="District"
                label="地區"
                color="secondary"
                variant="outlined"
                fullWidth
                value={storeData.District || ""}
                onChange={handleChange}
              />
              <TextField
                margin="dense"
                name="Address"
                label="地址"
                color="secondary"
                variant="outlined"
                required={true}
                fullWidth
                value={storeData.Address || ""}
                onChange={handleChange}
              />

              <TextField
                margin="dense"
                name="Phone"
                label="電話"
                color="secondary"
                required={true}
                variant="outlined"
                fullWidth
                value={storeData.Phone || ""}
                onChange={handleChange}
              />
              <StoreStatusSelect></StoreStatusSelect>
              <IntervalMinutesSelect></IntervalMinutesSelect>
              <TextField
                margin="dense"
                name="Description"
                label="描述"
                color="secondary"
                variant="outlined"
                fullWidth
                value={storeData.Description || ""}
                onChange={handleChange}
              />
            </Box>
            <Box width={"50%"} flexDirection={"colunm"}>
              {generateTagToggles()}
              {generatePromotionFields()}
              {!isAdd ? null : (
                <TextField
                  margin="dense"
                  name="Tables"
                  label="桌數"
                  color="secondary"
                  variant="outlined"
                  fullWidth
                  value={storeData.Tables || 0}
                  onChange={handleChange}
                />
              )}
            </Box>
          </Stack>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleClose} color="secondary">
            取消
          </Button>
          <Button type="submit" color="secondary">
            確認
          </Button>
        </DialogActions>
      </form>
    </Dialog>
  );
};

export default AddStoreDialog;
